import React, { useContext, useState } from "react";
import { ContextList } from "../listContext";
import StorageLocal from "../../../../inc/StorageLocal";
import { isNarrowScreen } from "../../../../inc/Responsive";
import Button from "../../../components/button";
import Select from "../../../components/inputs/select";
import "./styles.css";

// Интервалы автообновления списка, сек (0 — выключено).
const REFRESH_INTERVAL_OPTIONS = {
    0: 'Выкл',
    5: '5 сек',
    15: '15 сек',
    30: '30 сек',
    60: '1 мин',
};

// Раскрыта ли панель фильтров. Одно значение на всю панель (не на раздел): фильтруют
// эпизодически, а место занимают всегда — на телефоне это был целый экран над списком.
// По умолчанию свёрнуто; выбор оператора запоминается.
const FILTERS_OPEN_KEY = 'LIST_FILTERS_OPEN';

// Панель фильтров списка: свёрнутая строка (переключатель, «Всего записей», автообновление) и,
// когда раскрыта, инпуты страницы + «Применить»/«Сбросить».
export default function ListFilters() {
    const contextList = useContext(ContextList);
    const hasFilters = Array.isArray(contextList.filters) && contextList.filters.length > 0;
    const activeCount = contextList.activeFiltersCount ?? 0;

    const [isOpen, setIsOpen] = useState(() => StorageLocal.Get(FILTERS_OPEN_KEY, false));
    const changeOpen = (open) => {
        setIsOpen(open);
        StorageLocal.Set(FILTERS_OPEN_KEY, open);
    };

    const handleApply = () => {
        contextList.onApplyFilters();
        // На узком экране после применения панель убирается сама — ради результата её и
        // открывали, а он на телефоне весь под ней.
        if (isNarrowScreen()) changeOpen(false);
    };

    return <div className="list__filters">
        <div className="list__filters-bar">
            {hasFilters
                ? <button
                    type="button"
                    className="list__filters-toggle"
                    onClick={() => changeOpen(!isOpen)}
                >
                    <span className="list__filters-toggle-arrow">{isOpen ? '▾' : '▸'}</span>
                    Фильтры
                    {/* Сколько фильтров применено: на свёрнутой панели это единственный признак,
                        что список показывает не всё. */}
                    {activeCount > 0 ? <span className="badge badge_accent">{activeCount}</span> : null}
                </button>
                : null}
            {/* Всего по текущему фильтру, а не на странице: страница — не больше per_page. */}
            {contextList.total !== null
                ? <span className="list__filters-total">Всего записей: {contextList.total}</span>
                : null}
            <div className="list__filters-refresh">
                <Select
                    className="input_wf"
                    options={REFRESH_INTERVAL_OPTIONS}
                    value={contextList.refreshInterval}
                    onChange={(event) => contextList.setRefreshInterval(parseInt(event.target.value, 10) || 0)}
                >
                    Автообновление
                </Select>
            </div>
        </div>

        {hasFilters && isOpen
            ? <div className="list__filters-form">
                <div className="list__filters-inputs">
                    {contextList.filters.map((filter, index) =>
                        <div key={index} className="list__filters-input">{filter}</div>
                    )}
                </div>
                <div className="list__filters-actions">
                    <Button className="btn-success" onClick={handleApply}>Применить</Button>
                    <Button onClick={contextList.onResetFilters}>Сбросить</Button>
                </div>
            </div>
            : null}
    </div>;
}
